import { render, staticRenderFns } from "./receivingsupplierfrm.vue?vue&type=template&id=520dfe1e"
import script from "./receivingsupplierfrm.vue?vue&type=script&lang=js"
export * from "./receivingsupplierfrm.vue?vue&type=script&lang=js"
import style0 from "./receivingsupplierfrm.vue?vue&type=style&index=0&id=520dfe1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports